import { render, staticRenderFns } from "./serverAgreement.vue?vue&type=template&id=cbc76b88&scoped=true&"
import script from "./serverAgreement.vue?vue&type=script&lang=js&"
export * from "./serverAgreement.vue?vue&type=script&lang=js&"
import style0 from "./serverAgreement.vue?vue&type=style&index=0&id=cbc76b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc76b88",
  null
  
)

export default component.exports